import React, { FC, memo } from 'react';
import UserSelectDropdown from '../../components/shared/UserSelectDropdown/UserSelectDropdown';
import { UserOption } from '../../utils/helpers/user/userOptionsBuilder';
import { USER_FORMAT_PRESETS, UserData } from '../../utils/helpers/text/userFormatting';

interface SigneeFilterProps {
  signeeFilter: UserOption | UserData | null;
  allUsers: any[];
  onSigneeFilterChange: (selectedSignee: UserOption) => void;
  width?: number;
  disabled?: boolean;
  style?: React.CSSProperties;
}

/**
 * SigneeFilter - Wrapper around UserSelectDropdown for signee filtering
 */
const SigneeFilter: FC<SigneeFilterProps> = memo(({
  signeeFilter,
  allUsers,
  onSigneeFilterChange,
  width = 200,
  disabled = false,
  style = {}
}) => {
  const handleChange = (selected: UserOption | null, _userData?: any) => {
    if (selected) {
      onSigneeFilterChange(selected);
    } else {
      // Reset to "All users"
      onSigneeFilterChange({ name: "", label: "All users" });
    }
  };

  return (
    <UserSelectDropdown
      value={signeeFilter}
      users={allUsers}
      onChange={handleChange}
      optionsConfig={{
        formatConfig: USER_FORMAT_PRESETS.default,
        includeAllUsers: true,
        allUsersPosition: 'first',
        allUsersLabel: "All users",
        enableSort: true
      }}
      label="Signee"
      placeholder="Type to search users"
      width={width}
      disabled={disabled}
      style={style}
      dataTestid="signee-filter-dropdown"
      name="signeeFilter"
      clearable={true}
      returnUserData={true}
    />
  );
});

export default SigneeFilter;
